module.exports = __webpack_public_path__ + "img/3.df2a5985.jpg";